var label = {
  color: 'gray.400',
  textStyle: 'text',
  opacity: 1,
  transitionProperty: 'common',
  transitionDuration: 'normal',
  _disabled: {
    opacity: 0.4
  }
};
var label$1 = label;
export { label$1 as default };